import { Icon } from '@shopify/polaris';
import type { IconSource } from '@shopify/polaris';

export type IconBadgeColor = 'purple' | 'indigo' | 'orange' | 'teal' | 'green' | 'pink' | 'blue';

interface IconBadgeProps {
  icon: IconSource;
  color?: IconBadgeColor;
}

export function IconBadge({ icon, color = 'indigo' }: IconBadgeProps) {
  return (
    <span className={`gp-icon-badge gp-icon-badge--${color}`}>
      <Icon source={icon} />
    </span>
  );
}
